import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { ArrowButton } from "../components/Buttons";
import { PROCESS } from "../data/site";

const Process = () => (
  <div data-testid="process-page">
    <PageHeader
      label="Our Process"
      lines={["From first thought", "to final impact."]}
      intro="A clear, considered path from understanding your brand to building for long-term growth."
    />

    <section className="bg-cream pb-24 md:pb-32">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="border-t border-dark-text/10">
          {PROCESS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.05}>
              <div className="group grid md:grid-cols-12 gap-4 md:gap-10 py-12 md:py-16 border-b border-dark-text/10 items-baseline">
                <div className="md:col-span-3 flex items-baseline gap-4">
                  <span className="font-mono text-sm text-dark-text/40">{step.num}</span>
                  <span className="w-10 h-px bg-dark-text/25 group-hover:w-16 transition-all duration-500" />
                </div>
                <h2 className="md:col-span-4 font-serif text-4xl md:text-6xl tracking-tight text-dark-text leading-none group-hover:text-secondary-green transition-colors duration-500">
                  {step.title}
                </h2>
                <p className="md:col-span-5 font-sans text-base md:text-lg text-dark-text/70 leading-relaxed">
                  {step.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-20 text-center">
          <p className="font-serif text-2xl md:text-4xl tracking-tight text-dark-text max-w-2xl mx-auto leading-tight">
            A process built to turn ideas into measurable, lasting growth.
          </p>
          <div className="mt-10 flex justify-center">
            <ArrowButton to="/contact" testid="process-start-project">Start a Project</ArrowButton>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Process;
